import { render, staticRenderFns } from "./FigureInfoPage.vue?vue&type=template&id=81495290&scoped=true&"
import script from "./FigureInfoPage.vue?vue&type=script&lang=js&"
export * from "./FigureInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./FigureInfoPage.vue?vue&type=style&index=0&id=81495290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81495290",
  null
  
)

export default component.exports